export function isWeightKey(key) {
  const value = String(key || '').trim().toLowerCase();
  return value.includes('weight') || value.includes('وزن');
}

export function readWeightInfo(product) {
  const sources = [product, product?.tech_data, product?.tech_data?.specs, product?.features, product?.specs].filter(Boolean);
  let weightUnit = product?.weight_unit || '';
  for (const source of sources) {
    for (const [key, value] of Object.entries(source || {})) {
      if (/^(?:weight_unit|واحد\s*وزن|واحد\s*اندازه.?گیری\s*وزن)$/i.test(key.trim()) && value) weightUnit = String(value);
    }
  }
  const result = (value, label) => ({ weight_value: String(value), weight_label: label, weight_unit: weightUnit });
  if (product?.weight_value != null && String(product.weight_value).trim()) {
    return result(product.weight_value, product.weight_label || 'weight');
  }
  const preferredKeys = ['weight', 'وزن', 'وزن واحد', 'وزن هر شاخه', 'weight_kg', 'unit_weight'];

  for (const source of sources) {
    if (!source || typeof source !== 'object' || Array.isArray(source)) continue;

    for (const key of preferredKeys) {
      const value = source[key];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        return result(value, key);
      }
    }

    for (const [key, value] of Object.entries(source)) {
      const unitOrLabel = /^(?:weight[_ ]?unit|weight_label|واحد(?:\s*اندازه.?گیری)?\s*وزن)$/i.test(key.trim());
      if (isWeightKey(key) && !unitOrLabel && value !== undefined && value !== null && String(value).trim() !== '' && typeof value !== 'object') {
        return result(value, key);
      }
    }
  }

  return { weight_value: null, weight_label: null, weight_unit: weightUnit };
}

export function parseWeight(value, label = '') {
  const raw = String(value ?? '').trim();
  if (!raw) return null;

  const normalized = raw
    .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
    .replace(/,/g, '.');
  const match = normalized.match(/[-+]?\d*\.?\d+/);
  if (!match) return null;

  const amount = Number(match[0]);
  if (!Number.isFinite(amount)) return null;

  const unitText = `${raw} ${label}`.toLowerCase();
  if (unitText.includes('گرم') && !unitText.includes('کیلو')) {
    return { amount, unit: 'گرم', kg: amount / 1000 };
  }
  if (/(?:^|[\s\d_()])(?:g|gr|gram|grams)(?:$|[\s/()])/i.test(unitText) && !/(?:kg|kilogram)/i.test(unitText)) {
    return { amount, unit: 'گرم', kg: amount / 1000 };
  }
  return { amount, unit: 'کیلوگرم', kg: amount };
}

export function formatKg(value) {
  const amount = Number(value) || 0;
  return `${amount.toLocaleString('fa-IR', { maximumFractionDigits: 3 })} کیلوگرم`;
}

export function formatWeight(amount, unit) {
  return `${Number(amount || 0).toLocaleString('fa-IR', { maximumFractionDigits: 3 })} ${unit}`;
}

export function weightLine(item) {
  const info = readWeightInfo(item);
  const parsed = parseWeight(info.weight_value, `${info.weight_label || ''} ${info.weight_unit || ''}`);
  const quantity = Math.max(Number(item?.quantity) || 0, 0);
  const totalKg = parsed ? parsed.kg * quantity : 0;

  return {
    ...info,
    parsed,
    quantity,
    totalKg,
    hasWeight: Boolean(info.weight_value),
  };
}
